module.exports = __webpack_public_path__ + "img/men_default_right.cf250a89.png";